import useAPIs from "./useAPIs";

const CommonAPIs = () => {
  const { postData, getData } = useAPIs();

  const fetchLocationsFromPincode = (pincode, onSuccess) => {
    getData(
      `/sales/v1/location/list/${pincode}`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const CheckEligStatus = (payload, onSuccess) => {
    postData(
      "/sales/v1/order/new/eligstatus",
      payload,
      (data) => {
        console.log(data);
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchProductsFromPincode = (pincode, onSuccess) => {
    let city_id = "";
    let district_id = "";
    let state_id = "";
    let country_id = "";
    let product_category = "";
    let pv = "";
    let search_key = "";
    getData(
      `/sales/v1/products/vo?postcode_id=${pincode}&city_id=${city_id}&district_id=${district_id}&state_id=${state_id}&country_id=8${country_id}&product_category=${product_category}&pv=${pv}&search_key=${search_key}`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchStoresWarehouses = (pincode, onSuccess) => {
    let warehouse_type_id = "";
    let city_id = "";
    let district_id = "";
    let state_id = "";
    let country_id = "";
    getData(
      `/sales/v1/warehouse/list?warehouse_type_id=${warehouse_type_id}&postalcode_id=${pincode}&city_id=${city_id}&district_id=${district_id}&state_id=${state_id}&country_id=${country_id}`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchUplineVotm = (payload, onSuccess) => {
    postData(
      "/enrollment/fetch-votm-uplines",
      payload,
      (data) => {
        console.log(data);
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchDeliveryModes = (pincode, onSuccess) => {
    let city_id = "";
    let district_id = "";
    let state_id = "";
    let country_id = "";
    getData(
      `/sales/v1/master/deliverymodes?postcode_id=${pincode}&city_id=${city_id}&district_id=${district_id}&state_id=${state_id}&country_id=${country_id}`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const fetchWalletDetails = (dist_id, onSuccess) => {
    getData(
      `/sales/v1/wallet/${dist_id}`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const postOrderSummary = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/order-summary",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const fetchDistDetails = (payload, onSuccess, onError) => {
    postData(
      "/enrollment/fetch-distributor-details",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  return {
    fetchLocationsFromPincode,
    CheckEligStatus,
    fetchProductsFromPincode,
    fetchStoresWarehouses,
    fetchUplineVotm,
    fetchDeliveryModes,
    fetchWalletDetails,
    postOrderSummary,
    fetchDistDetails,
  };
};

export default CommonAPIs;
